<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="充电站:" :label-width="100">
				<Select filterable placeholder="站点列表" style="width: 200px;" v-model="formInline.StationId">
					<Option :value=0>全部</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.OrderNo" placeholder="订单单号">
				<span slot="prepend">订单单号</span>
				</Input>
			</FormItem>
			<!-- <FormItem label="开始时间" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeBegin"></DatePicker>
			</FormItem> -->
			<!-- <FormItem label="结束时间" :label-width='70'>
				<DatePicker style="width: 110px;" type="date" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeEnd"></DatePicker>
			</FormItem> -->
			<FormItem label="选择时间" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			<FormItem label="" :label-width='0'>
				<Input type="text" v-model="formInline.MemberName" placeholder="会员名称">
				<span slot="prepend">会员名称</span>
				</Input>
			</FormItem>
			<FormItem label="" :label-width='0'>
				<Input type="text" v-model="formInline.EquipmentNo" placeholder="设备编号">
				<span slot="prepend">设备编号</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">导出文件</Button>
			</FormItem>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight" :loading="loadingData" ref="ChargingOrder" size="small"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getAbnormalOrderUrl" @listData='getDeviceData'></MyPage>
		<AbnormalOrderModal @handleSubmit="handleSubmit" ref="AbnormalOrderModal"></AbnormalOrderModal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import AbnormalOrderModal from './AbnormalOrderTemplate/AbnormalOrderModal.vue'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		components: {
			AbnormalOrderModal
		},
		data() {
			return {
				getAbnormalOrderUrl: webapi.base_api_url + '/Order/GetAbnormalOrder',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "有家充电站",
				tableHeight: "650",
				modal: {
					Title: "设备信息添加",
					type: "addDevice"
				},
				BreadcrumbList: ['订单记录', '>>', '异常订单'],
				formInline: {
					StationId: 0,
					OrderNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 31), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 31), new Date()],
					MemberName: '',
					EquipmentNo: ''
				},
				loadingData: false,
				//table标题数据
				columns1: [
					// {
					// 	type: 'expand',
					// 	width: 50,
					// 	render: (h, params) => {
					// 		return h(expandRow, {
					// 			props: {
					// 				row: params.row
					// 			}
					// 		})
					// 	}
					// }, 
					{
						title: '订单单号',
						key: 'OrderNo',
						minWidth: 120,
					}, {
						title: '订单时间',
						key: 'OrderTime',
						minWidth: 120,
					},
					{
						title: '订单来源',
						key: 'TradeType',
						minWidth: 120,
						render: (h, params) => {
							return h('div', params.row.TradeTypeDesc);
						}
					},
					{
						title: '订单状态',
						key: 'OrderStatus',
						minWidth: 120,
						render: (h, params) => {
							return h('div', params.row.OrderStatusDesc);
						}
					},
					{
						title: '会员手机号码',
						key: 'MemberPhone',
						minWidth: 120,
					},
					{
						title: '会员名称',
						key: 'MemberName',
						minWidth: 120,
					},
					{
						title: '预付金额(元)',
						key: 'OrderAmount',
						minWidth: 120,
					},
					// {
					// 	title: '充电总费用',
					// 	key: 'ChargeCost'
					// },
					// {
					// 	title: '优惠金额',
					// 	key: 'CouponAmount'
					// },
					// {
					// 	title: '结算金额',
					// 	key: 'CouponCost'
					// },
					{
						title: '枪编号',
						key: 'ConnectorNo',
						minWidth: 120,
					},
					{
						title: '站点名称',
						key: 'StationName',
						minWidth: 120,
					}, {
						title: '操作',
						key: 'action',
						minWidth: 200,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								// this.hasWidgets('refund') ? h('Button', {
								// 		props: {
								// 			type: 'error',
								// 			size: 'small'
								// 		},
								// 		style: {
								// 			marginRight: '5px'
								// 		},
								// 		on: {
								// 			click: () => {
								// 				this.$Modal.confirm({
								// 					title: "确认直接退款？",
								// 					content: '请确保桩在线且无充电记录上报，以免造成损失。目前桩状态为[' + params.row.WorkStatusDesc + ']',
								// 					okText: '取消',
								// 					cancelText: '确定',
								// 					onCancel: () => {
								// 						this.show("refund", params.row.OrderNo)
								// 					}
								// 				})
								// 			}
								// 		}
								// 	},
								// 	'直接退款') : h(),
								// this.hasWidgets('fixOrder') ? h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		click: () => {
								// 			this.$Modal.confirm({
								// 				title: "确认恢复订单，手动结算？",
								// 				content: '请确保桩在线且无充电记录上报，以免造成损失。目前桩状态为[' + params.row.WorkStatusDesc + ']',
								// 				okText: '取消',
								// 				cancelText: '确定',
								// 				onCancel: () => {
								// 					this.show("regain", params.row.OrderNo)
								// 				}
								// 			})
								// 		}
								// 	}
								// }, '恢复订单') : h(),
								this.hasWidgets('manualSettle') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.$Modal.confirm({
												title: "确认手动结算？",
												content: '请确保桩在线且无充电记录上报，以免造成损失。手动结算将尝试使用充电曲线信息进行结算。',
												okText: '取消',
												cancelText: '确定',
												onCancel: () => {
													this.show("regain", params.row.OrderNo)
												}
											})
										}
									}
								}, '手动结算') : h(),
							]);
						}
					}
				],
				data1: []
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					OrderNo: _this.formInline.OrderNo,
					TimeBegin: _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeBegin), 'yyyy-MM-dd'),
					TimeEnd: _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeEnd), 'yyyy-MM-dd'),
					EquipmentNo: _this.formInline.EquipmentNo,
					MemberName: _this.formInline.MemberName
				}
				return param
			},
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("日期改变：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			exportFile: function() {
				this.$refs.ChargingOrder.exportCsv({
					filename: '异常订单',
					columns: this.columns1,
					data: this.data1.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.OrderTime = '\t' + (k.OrderTime || '');
						// k.StartTime = '\t' + (k.StartTime || '');
						// k.EndTime = '\t' + (k.EndTime || '');
						// k.RefundTime = '\t' + (k.RefundTime || '');
						return k;
					})
				})
			},
			//操作
			show: function(type, params) {
				const _this = this;
				switch (type) {
					//退款
					// case "refund":
					// 	_this.refund(params)
					// 	break;
					case "regain": //恢复
						_this.$refs.AbnormalOrderModal.show(type, params)
						break;
					default:
						break;
				}
			},

			// refund: function(OrderNo) {
			// 	this.$axios.post(webapi.base_api_url + "/Order/OrderRefund", {
			// 		OrderNo: OrderNo
			// 	}).then(res => {
			// 		console.log("直接退款")
			// 		if (res.data.Code == 0) {
			// 			this.$Message.success(res.data.Msg);
			// 		} else {
			// 			this.$Message.success(res.data.Msg + "---" + res.data.Data);
			// 		}
			// 	})
			// },
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List;
				this.loadingData = false;
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.loadingData = true;
				this.$refs.sonPage.getList();
				// const _this = this;
				// let parms = _this.formInline;
				// _this.$axios.post(webapi.base_api_url + "/Order/GetChargeOrder", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.AlarmingInfos;
				// 	}
				// })
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
